export const loading = () => {
  return {
    type: "LOADING_ITEMS"
  };
};

export const success = () => {
  return {
    type: "SUCCESS_ON_ITEMS"
  };
};

//redux-thunk handles the async operations using dispatch, simply follow this pattern
export const getItems = val => {
  return async dispatch => {
    dispatch(loading());
    let res = await (await fetch(`https://mosi-api.herokuapp.com/api/items/${val}`, {
      headers: {
        'x-access-token': `${localStorage.getItem("token")}`
      },
    })).json();
    console.log(res);
    dispatch({
      type: "GET_USER_ITEMS",
      value: res.reverse()
    })
  };
};

export const addItem = val => {
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/items`, {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify(val)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ITEMS" }) }

    console.log(res);
    dispatch(success());
    dispatch(getItems(val.userId));
  };
  // return { type: "ADD_ORDER", value: val };
};

export const updateItem = val => {
  let imageName = '';
  if (val.imageURL) {
    imageName = val.imageURL.replace('https://miso-app.s3.eu-west-2.amazonaws.com/', '')
  }
  const data = { ...val, imageName };
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/items/${data._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(data)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ITEMS" }) }

    console.log(res);
    dispatch(success());
    dispatch(getItems(val.userId))
  };
  // return { type: "ADD_ORDER", value: val };
};

export const removeItem = val => {
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      let imageName = val.imageURL.replace('https://miso-app.s3.eu-west-2.amazonaws.com/', '');
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/items/${val.itemId}/${imageName}`, {
        method: 'DELETE',
        headers: {
          'x-access-token': `${localStorage.getItem("token")}`
        },
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ITEMS" }) }

    console.log(res);
    dispatch(success());
    window.location.reload()
  };
  // return { type: "ADD_ORDER", value: val };
};

export const resetStatus = () => {
  return { type: "RESET_ITEM_STATUS" };
};